<template>
<div class="container">
    <h4>QR Generator IDP STG ENV POC v1 - Instructions</h4>
    <p><strong>Code Value: <a href="codeValue">{{ codeValue }} </a></strong></p>
    <div class="qr-container">
        <qrcode-vue :value="codeValue" :size="200" level="H"></qrcode-vue>
        
        <p>This is using a generated link via the Branch SDK.</p>
        <p>LOGIN.TEST</p>
        <div class="row">
            <div class="col">
                <p>If you see a link, open this link on your mobile device. <a href="codeValue">{{ codeValue }}</a></p>
                <p>Click "Generate New Code" button</p>
                <p>Scan QR code below from your mobile device's native camera or in OneApp.</p>
                <p>Watch magic happen</p>
            </div>
        </div>
    </div>
    <div class="py-3" style="text-align: center">
        <button class="ty-button" v-on:click="generate">Generate New Code</button>
    </div>
    <div v-if="scanResponse">
        <p>Scan Response:</p>
        <p>{{scanResponse}}</p>
    </div>

</div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import Branch from 'branch-sdk';

import {
    analytics
} from '../../config/firebaseInit'

export default {
    name: 'QrGeneratorGL',
    data: function () {
        return {
            // deepURL: 'https://toyota-one.app.link/smartlink?$user_code=',
            deepToyotaURL: 'https://toyota.test-app.link/sms_registration',
            deepLexusURL: 'https://toyota.test-app.link/sms_registration',
            codeValue: '',
            scanResponse: null
        }
    },
    props: {
        msg: String
    },
    components: {
        QrcodeVue
    },
    created() {
        analytics.logEvent('qr-idp-gl');
    },
    methods: {
        generate: function () {
            // this.axios.get('https://us-central1-tmna-onescan.cloudfunctions.net/api/generate-code').then((response) => {
            //   this.codeValue = response.data.user_code
            // }).catch((e) => {
            //   console.log(e);
            //   this.codeValue = "1234"
            // })
            //https://idp.stg.connectedtech.io/oauth2/device/user?user_code=ecJT3q5C
            //https://idp.stg.connectedtech.io/oauth2/realms/root/realms/tmna/device/code
            //https://idp.stg.connectedtech.io/openam/device/code
            this.axios.post('https://login.test.forgerock-login.com/oauth2/realms/tmna/device/code?response_type=token&scope=profile&client_id=headunit', {
                headers: {
                    'Host': 'login.test.forgerock-login.com',
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
            }).then((response) => {
                // eslint-disable-next-line
                console.log("qr response: ", response);
                this.scanResponse = response.data;
                //const userCodeURL = `${response.data.verification_url}` + '?user_code=' + response.data.user_code;
                //this.codeValue = this.deepURL+response.data.user_code;
                //this.codeValue = userCodeURL;
                this.branchify(response.data.verification_url,response.data.user_code)
            }).catch(() => {
                this.codeValue = "Error"
            })
        },
        branchify: function (verification_url,user_code) {
            //Branch.init('key_live_gnSEzFNyt77pHgZ17MC6LjonDBiucgKP')
            Branch.init('key_test_ebG3l8xMO5xVZBSSSZFs5lenrDdfQ6B7')
            var linkData = {
                campaign: 'sms_registration',
                channel: 'hu',
                feature: 'vehicle registration',
                stage: 'new user',
                // tags: [ 'tag1', 'tag2', 'tag3' ],
                alias: '',
                data: {
                    'custom_bool': true,
                    'custom_int': Date.now(),
                    'custom_string': 'hello',
                    'verification_url':verification_url+'?user_code='+user_code,
                    'user_code':user_code,
                    '$og_title': 'Vehicle Registration',
                    '$og_description': 'Description',
                    '$og_image_url':'http://lorempixel.com/400/400',
                    '$ios_deeplink_path': 'sms/registration',
                    '$deeplink_path': 'sms/registration',
                    '$android_deeplink_path': 'sms/registration',
                },
                make_new_link:false
            };
            Branch.link(linkData, (err, link) => {
                // eslint-disable-next-line no-console
                this.codeValue = link
            })
            
            
        }

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
body {
    font-family: ToyotaType-Regular;
}

h3 {
    margin: 40px 0 0;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #42b983;
}

.ty-button {
    background: #D92429;
    border-radius: 0px;
    width: 343px;
    height: 64px;
    font-family: ToyotaType-Semibold;
    font-size: 24px;
    color: #FFFFFF;
    letter-spacing: 0.73px;
    text-align: center;
}

.lx-button {
    background: #000000;
    border-radius: 0px;
    width: 360px;
    height: 64px;
    font-family: ToyotaType-Semibold;
    font-size: 24px;
    color: #FFFFFF;
    letter-spacing: 0.73px;
    text-align: center;
}

.qr-container {
    padding-top: 40px;
    text-align: center;
    height: 300px;
    /*background-color: #4281ff;*/
    height: 540px;
}
</style>
